// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7bf82b30","732":"98d1c1af","977":"a8cb6a31"}[chunkId] + ".chunk.js";
};